import { render } from "./orderCancel.vue?vue&type=template&id=d8677212"
import script from "./orderCancel.vue?vue&type=script&lang=js"
export * from "./orderCancel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__